module.exports = __webpack_public_path__ + "static/img/putiItemNew1.7b83888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/putiItemNew1.jpg
// module id = pgp/
// module chunks = 0